import { Link, useParams } from "react-router-dom";
import { news } from "@/mocks/news";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NewsDetail() {
  const { id } = useParams();
  const item = news.find((article) => article.id === id);

  usePageMeta(
    item ? `${item.title} - 影视资讯 - 后入影视网` : "影视资讯 - 后入影视网",
    item
      ? item.summary
      : "后入影视网影视资讯详情页，提供最新影视新闻与深度报道。",
    item ? `${item.category},影视资讯,影视新闻,后入影视` : undefined
  );

  if (!item) {
    return (
      <div className="mx-auto flex w-full flex-col items-center px-4 py-24 text-center md:px-6">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-secondary-400">
          <i className="ri-file-unknow-line text-3xl"></i>
        </span>
        <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950">
          未找到该资讯
        </h1>
        <p className="mt-2 text-sm text-secondary-500">
          该资讯可能已被删除或链接有误
        </p>
        <Link
          to="/news"
          className="mt-5 flex items-center gap-1.5 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-arrow-left-line"></i>
          返回资讯列表
        </Link>
      </div>
    );
  }

  const related = news
    .filter((article) => article.id !== item.id)
    .slice(0, 3);

  return (
    <div className="pb-16">
      <div className="mx-auto w-full px-4 pt-8 md:px-6">
        <Breadcrumb
          items={[
            { label: "首页", to: "/" },
            { label: "影视资讯", to: "/news" },
            { label: item.category },
          ]}
        />
      </div>

      <article className="mx-auto w-full px-4 md:px-6">
        <div className="mx-auto mt-6 max-w-3xl">
          <span className="inline-block rounded bg-accent-50 px-3 py-1 text-xs font-medium text-accent-700">
            {item.category}
          </span>
          <h1 className="mt-4 font-heading text-2xl font-extrabold leading-snug text-foreground-950 md:text-3xl">
            {item.title}
          </h1>
          <div className="mt-4 flex flex-wrap items-center gap-4 border-b border-background-200 pb-5 text-sm text-secondary-500">
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line"></i>
              发布时间：{item.date}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-user-3-line"></i>
              后入影视网编辑部
            </span>
          </div>

          <div className="mt-6 h-56 w-full overflow-hidden rounded-lg bg-background-100 md:h-80">
            <img
              src={item.cover}
              alt={`${item.title} 资讯配图`}
              title={`${item.title} 影视资讯`}
              className="h-full w-full object-cover object-center"
            />
          </div>

          <div className="mt-8 flex flex-col gap-5">
            <p className="rounded-md bg-background-100 p-4 text-sm leading-relaxed text-foreground-700">
              {item.summary}
            </p>
            {item.content.map((paragraph, index) => (
              <p
                key={index}
                className="text-sm leading-loose text-foreground-700 md:text-base"
              >
                {paragraph}
              </p>
            ))}
          </div>

          <div className="mt-8 rounded-lg border border-dashed border-background-300 bg-background-50 p-4 text-xs leading-relaxed text-secondary-500">
            注：本页内容为演示用途的虚构文章，仅用于展示资讯模块的排版与交互，不代表任何真实报道。
          </div>
        </div>
      </article>

      <section className="mx-auto mt-12 w-full px-4 md:px-6">
        <div className="mx-auto max-w-3xl">
          <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950 md:text-xl">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-50 text-accent-500">
              <i className="ri-links-line"></i>
            </span>
            相关资讯
          </h2>
          <ul className="mt-4 flex flex-col gap-3">
            {related.map((article) => (
              <li key={article.id}>
                <Link
                  to={`/news/${article.id}`}
                  className="group flex items-center justify-between gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-accent-300"
                >
                  <span className="flex min-w-0 flex-col">
                    <span className="truncate text-sm font-medium text-foreground-900 group-hover:text-accent-600">
                      {article.title}
                    </span>
                    <span className="mt-1 text-xs text-secondary-500">
                      {article.category} · {article.date}
                    </span>
                  </span>
                  <i className="ri-arrow-right-s-line shrink-0 text-xl text-secondary-400"></i>
                </Link>
              </li>
            ))}
          </ul>
          <div className="mt-6 flex justify-center">
            <Link
              to="/news"
              className="flex items-center gap-1.5 rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-600"
            >
              <i className="ri-arrow-left-line"></i>
              返回资讯列表
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}